import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SafeJsonPipe } from '../../pipes/safe-json.pipe';
import { EvaluationService } from '../../services/evaluation.service';
import { MessagesStateService } from '../../services/messages-state.service';
import { DynamicFlowService } from '../../services/dynamic-flow.service';
import { IAgentCard } from '../../models/agent.models';
import { ChatUserSettings } from '@dataclouder/ngx-core';
import { SliderModule } from 'primeng/slider';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { GlobalToolsService } from '../../services/global-tools.service';

@Component({
  selector: 'dc-conversation-info',
  standalone: true,
  imports: [CommonModule, SafeJsonPipe, SliderModule, ButtonModule, FormsModule, DividerModule],
  templateUrl: './conversation-inspector.html',
  styleUrls: ['./conversation-inspector.scss'],
})
export class ConversationInspector {
  public evaluationService = inject(EvaluationService);
  public messageStateService = inject(MessagesStateService);
  public dynamicFlowService = inject(DynamicFlowService);
  public globalToolsService = inject(GlobalToolsService);
  public config = inject(DynamicDialogConfig);

  agentCard: IAgentCard;
  chatUserSettings: ChatUserSettings;
  value = 0;

  constructor() {
    this.agentCard = this.config.data.agentCard;
    this.chatUserSettings = this.config.data.chatUserSettings;
  }

  setScore() {
    this.evaluationService.setScore(this.value);
  }

  public callAgent() {
    this.globalToolsService.useTool('closeChatDrawer');
  }
}
